export default __webpack_public_path__ + "static/media/digitalStage.27487c28.jpg";